import React, { useEffect } from "react";
import "../styles/common-header.css";
import logo from "../assets/images/iec-logo.png";

const CommonHeader = () => {
  useEffect(() => {
    const toggle = document.getElementById("toggle");
    const navbarCollapse = document.getElementById("navbarCollapse");
    const toggleMini = document.getElementById("toggle-mini");

    const handleToggleClick = () => {
      toggle.classList.toggle("is-active");
      navbarCollapse.classList.toggle("is-active");
    };

    const handleToggleMiniClick = () => {
      toggle.classList.toggle("is-active");
      navbarCollapse.classList.toggle("is-active");
    };

    toggle?.addEventListener("click", handleToggleClick);
    toggleMini?.addEventListener("click", handleToggleMiniClick);

    return () => {
      toggle?.removeEventListener("click", handleToggleClick);
      toggleMini?.removeEventListener("click", handleToggleMiniClick);
    };
  }, []);

  const scrollToFooter = (e) => {
    e.preventDefault();
    const footer = document.getElementById("footer");
    if (footer) {
      footer.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      // Agar footer nahi mile, page reload ke baad #footer ke liye
      window.location.href = "/#footer";
    }
  };

  return (
    <section className="common-header">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="common-header-wrapper">
              <div className="common-header-logo-wrapper">
                <a className="logo-link" href="/">
                  <img src={logo} alt="logo" className="common-header-logo" />
                </a>
              </div>

              <nav className="Navbar">
                <button id="toggle" className="Toggle Navbar-toggle" type="button">
                  <span></span>
                </button>

                <div id="navbarCollapse" className="Navbar-menu">
                  <ul className="Navbar-menu-major">
                    <li>
                      <details>
                        <summary>
                          Our Story
                          <span className="lnr lnr-chevron-down"></span>
                        </summary>
                        <ul>
                          <li>
                            <a href="/about-us">About Us</a>
                          </li>
                          <li>
                            <a href="/our-process">Our Process</a>
                          </li>
                        </ul>
                      </details>
                    </li>
                    <li>
                      <a href="/our-work">Our Work</a>
                    </li>
                    <li>
                      <a href="/facilities">Facilities</a>
                    </li>
                    <li>
                      <a href="/">News & Blogs</a>
                    </li>
                    <li>
                      <a href="#footer" onClick={scrollToFooter}>
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommonHeader;
